






















import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({
})
export default class ErrorPage extends Vue {
	@Getter public error!: string;
}
